export const contest = {
    qjy: 'Pergi Trading',
    grbm: 'Pendaftaran Individu',
    qdl: 'Pergi Login',
    bsyjs: 'Kompetisi telah berakhir',
    bsjs: 'Kompetisi Berakhir',
    djs: 'Menuju Kompetisi Trading Simulasi {v1} (Hitungan Mundur)',
    days: 'Hari',
    hours: 'Jam',
    minutes: 'Menit',
    seconds: 'Detik',
    ljyq: 'Undang Sekarang',
    tdbm: 'Pendaftaran Tim',
    qzc: 'Pergi Daftar',
    qrsfgrbm: 'Konfirmasi ikut pendaftaran individu?',
    qxbm: 'Batalkan Pendaftaran',
    qrbm: 'Konfirmasi Pendaftaran',
    gxnbmcg: 'Selamat, pendaftaran berhasil, Anda akan mendapatkan 100K USDT modal simulasi',
    xzjs: 'Pilih peran yang Anda inginkan',
    cwty: 'Jadi Anggota Tim',
    cwtz: 'Jadi Kapten Tim',
    cjtd: 'Buat Tim',
    jtgz: 'Aturan Pembuatan Tim:',
    jtgz1: '1. Tim akan otomatis bubar jika kurang dari 5 orang dalam 24 jam setelah dibuat, dan secara otomatis mendaftar ke kompetisi individu simulasi',
    jtgz2: '2. Tidak bisa mendaftar kompetisi individu simulasi selama menunggu tim terbentuk',
    jtgz3: '3. Setelah tim terbentuk, Anda tidak bisa bergabung dengan tim lain atau kompetisi individu simulasi',
    tdmc: 'Nama Tim:',
    tdjj: 'Deskripsi Tim:',
    ljjt: 'Buat Tim Sekarang',
    tdmcbt: 'Silakan masukkan nama tim',
    tdjzbt: 'Silakan masukkan deskripsi tim',
    cjzdcg: 'Berhasil membuat tim!',
    xzjrtd: 'Pilih tim yang ingin Anda ikuti',
    sstdmc: 'Cari nama tim',
    dqzdsl: 'Jumlah tim saat ini: {v1}, pilih tim yang ingin Anda ikuti',
    ddtdrs: 'Jumlah anggota tim saat ini: {v1} orang',
    tdrs: 'Jumlah Anggota Tim:',
    tzmc: 'Nama Kapten:',
    jrtd: 'Bergabung dengan Tim',
    jrzdcg: 'Berhasil bergabung dengan tim!',
    grfxlj: 'Tautan Bagian Individu:',
    grtjm: 'Kode Referal Individu:',
    tdfxlj: 'Tautan Bagian Tim:',
    tdtjm: 'Kode Referal Tim:',
    tdtzm: 'Nama Kapten Tim:',
    bctp: 'Simpan Gambar',
    total: 'Total {v1} item',
    dd: 'Ke',
    qd: 'Konfirmasi',
    cyyj: 'Berpartisipasi dapat hadiah',
    jcdnn: 'Hadiah USDT menunggu Anda!',
    jzcj: 'Donasi keuntungan, ikut undian',
    dqjc: 'Hadiah saat ini:',
    qjz: 'Pergi Donasi',
    jzsm: 'Penjelasan Donasi',
    kjz: 'Anda saat ini dapat mendonasikan {v1} USDT ke dana amal, konfirmasi donasi?',
    qxjz: 'Batalkan Donasi',
    qrjz: 'Konfirmasi Donasi',
    jzcg: 'Selamat, donasi berhasil!',
    mnpjyds: 'Kompetisi Trading Simulasi',
    bm: 'Pendaftaran:',
    bs: 'Kompetisi:',
    hyspjyds: 'Kompetisi Trading Kontrak ',
    xhspjyds: 'Kompetisi Trading Spot',
    bmz: 'Sedang Pendaftaran',
    jqqd: 'Tunggu sebentar',
    bsz: 'Sedang Berkompetisi',
    yjs: 'Telah Berakhir',
    myptts: 'Kompetisi Tim Simulasi ',
    mypzmxs: 'Kompetisi Bintang Mingguan',
    mypgrs: 'Kompetisi Individu Simulasi',
    hyjyds: 'Kompetisi Trading Kontrak ',
    xhjyds: 'Kompetisi Trading Spot',
    my: 'Saya',
    pm: 'Peringkat',
    dync: 'Nama Panggilan Anggota',
    dm: 'Nama Tim',
    zdrs: 'Jumlah Anggota Tim',
    nc: 'Nama Panggilan',
    ljzjy: 'Total Trading Kumulatif',
    ljzjye: 'Total Volume Trading',
    ljzyll: 'Total Profitabilitas Kumulatif',
    zyll: 'Total Profitabilitas',
    zdjl: 'Hadiah Tim',
    mypbsjl: 'Hadiah Partisipasi',
    myphycs: 'Ikut Kompetisi Kontrak Simulasi',
    myhyj: 'Dapat 100.000U modal kontrak simulasi setelah pendaftaran berhasil',
    ljbm: 'Ikut Sekarang',
    tzjl: 'Hadiah Pembuatan Tim',
    ztcg: '5 orang jadi tim, maksimal 200 orang',
    bwzbhl: 'Kapten tim dapat 100.000U+ jika berhasil membuat tim',
    yqjl: 'Hadiah Undangan',
    yqhycybs: 'Undangan kapten, dapat hingga 100.000U',
    hzhyj: 'Undangan anggota, dapat hingga 50.000U',
    mnttbssm: 'Penjelasan Aturan Kompetisi Tim Simulasi',
    // Aturan kompetisi tim
    csxq: 'Detail Partisipasi:',
    csxq1: '1. Pengguna (setelah verifikasi identitas) dapat membuat tim kapan saja dari hari pendaftaran hingga hari berakhirnya kompetisi, kompetisi tim kontrak membutuhkan anggota tim ≥ 5 orang; ≤200 orang; jika tidak mencapai 5 orang dalam 24 jam, tim akan otomatis bubar dan anggota otomatis pindah ke zona individu.',
    csxq2: '2. Pengguna hanya dapat memilih dan bergabung dengan satu tim, tidak boleh berpartisipasi ganda, tidak boleh ikut kompetisi tim dan individu bersamaan, tidak bisa keluar tim setelah bergabung.',
    ssgz: 'Aturan Kompetisi:',
    ssgz1: '1. Benefit kapten: 1) Kapten dapat 1000USDT modal simulasi untuk setiap anggota yang diundang, hadiah undangan maksimal 100.000USDT;',
    ssgz1_2: '          2) Kapten dapat merchandise eksklusif BiKing jika berhasil mengundang lebih dari 20 orang dan mereka trading.',
    ssgz2: '2. Benefit anggota: Anggota dapat 500USDT modal kontrak simulasi untuk setiap teman yang diundang, hadiah undangan maksimal 50.000USDT',
    ssgz3: '3. Setelah kompetisi tim berakhir, platform akan menentukan peringkat akhir berdasarkan total volume trading tim',
    ssgz4: '4. Total volume trading zona tim simulasi akan diperbarui setiap hari jam 0:00',
    ssgz5: '5. Untuk keadilan hasil kompetisi, jangan melakukan trading palsu, jika ditemukan, tim layanan pelanggan BiKing akan turun tangan. Total volume trading zona tim simulasi diperbarui setiap hari jam 0:00',
    ssgz6: '6. Hubungi tim layanan pelanggan BiKing untuk detail aturan.',
    jlfp: 'Alokasi Hadiah:',
    jlfp1: '1. Alokasi hadiah USDT: (Saat distribusi, modal kontrak simulasi dan uang tunai dialokasikan dengan rasio 9:1)',
    jlfp1_1: '1) Rasio alokasi internal tim:',
    jlfp1_2: 'Hadiah kapten = Volume trading kontrak kumulatif kapten / Total volume trading kompetisi tim simulasi BiKing * 5.000.000USDT',
    jlfp1_3: '+ Total kinerja anggota lain / Total volume trading kompetisi tim simulasi BiKing * 20% * 5.000.000USDT.',
    jlfp1_4: 'Hadiah anggota = Volume trading kontrak kumulatif pengguna / Total volume trading kompetisi tim simulasi BiKing * 80% * 5.000.000USDT.',
    jlfp1_5: '2) Tim berkinerja baik selama kompetisi dapat bonus pendapatan kolektif! Rasio bonus berdasarkan jumlah anggota dan total volume trading tim, setiap kali jumlah anggota/volume trading berlipat ganda, dapat bonus 50% hashrate',
    myptdjyze: 'Total Volume Trading Zona Tim Simulasi',
    myptdphb: 'Papan Peringkat Tim Simulasi',
    tdsl: 'Jumlah tim saat ini: {v1}, pilih tim yang ingin Anda ikuti',
    tznc: 'Nama Panggilan Kapten:',
    tdjs: 'Deskripsi Tim:',
    // Aturan bintang mingguan
    mypzmxgzsm: 'Penjelasan Aturan Kompetisi Bintang Mingguan Simulasi',
    zmxphb: 'Papan Peringkat Tim Bintang Mingguan (hanya 3 teratas)',
    zmxtdphb: 'Papan Peringkat Tim Bintang Mingguan',
    bdxq: 'Detail Peringkat:',
    bdxq1: '1. Berhasil membuat tim dan mulai trading berarti otomatis ikut peringkat bintang mingguan',
    zmxgz: '1. Sistem akan mengambil setiap minggu kalender sebagai satu siklus, peringkat tim berdasarkan total volume trading, dan mengumumkan "Papan Peringkat Tim Bintang Mingguan", 3 tim teratas akan berbagi 2.000.000USDT hadiah modal kontrak simulasi',
    zmxgz1: '2. Papan Peringkat Tim Bintang Mingguan diperbarui setiap Rabu 14:00',
    bddym: 'Peringkat 1 dapat 1.000.000USDT modal kontrak simulasi;',
    dbdem: 'Peringkat 2 dapat 600.000USDT modal kontrak simulasi;',
    bddsm: 'Peringkat 3 dapat 400.000USDT modal kontrak simulasi;',
    tdnbfpgz: 'Aturan Alokasi Internal Tim:',
    tzx: 'Kapten dapat: 20%;',
    nbyjpm: '10 anggota teratas (selain kapten): Berbagi 40%',
    syty: 'Anggota lainnya: 40%',
    // Aturan kompetisi individu
    mypgrsgzsm: 'Penjelasan Aturan Kompetisi Individu Simulasi',
    mypgrphb: 'Papan Peringkat Individu Simulasi',
    bsxz: 'Yang Perlu Diketahui:',
    bsxz1: '1. Setiap pengguna baru dapat 100.000USDT modal kontrak simulasi setelah mendaftar',
    bsxz2: '2. Pengguna lama dapat 50.000USDT modal kontrak simulasi setelah mendaftar',
    bsxz3: '3. Selama kompetisi, pengguna dapat terus mendapatkan modal体验 melalui undangan teman:',
    bsxz4: '1) Dapat 2000USDT modal体验 untuk setiap teman yang diundang;',
    // bsxz5: '2) Dapat 2000USDT modal体验 untuk setiap pengguna lama yang diundang:',
    bsxz6: '2) Hadiah undangan maksimal 50.000USDT modal kontrak simulasi',
    bsxz7: '3. Zona ini hanya untuk pengguna terverifikasi BiKing.',
    bsxz8: '4. Peringkat akhir zona individu berdasarkan total volume trading akhir.',
    grgzsm1: '1. Total hadiah: 2.000.000USDT + 30 merchandise eksklusif',
    grgzsm2: '2. Detail alokasi:',
    grgzsm3: 'Peringkat 1: 800.000USDT + 5 merchandise',
    grgzsm4: 'Peringkat 2: 500.000USDT + 5 merchandise',
    grgzsm5: 'Peringkat 3: 200.000USDT + 3 merchandise',
    grgzsm6: 'Peringkat 4-20: Berbagi 500.000USDT + 17 merchandise',
    hyjybs: 'Kompetisi Trading Kontrak',
    hyjybsgzsm: 'Penjelasan Aturan Kompetisi Trading Kontrak',
    hyspgrphb: 'Papan Peringkat Individu Kontrak',
    // Aturan kompetisi kontrak
    csxz: 'Yang Perlu Diketahui:',
    hybsgz1: '1. Dapat modal khusus kontrak senilai 100USDT (standar penggunaan lihat aturan platform) setelah mendaftar, profit dari modal khusus tidak masuk ke total profitabilitas selama kompetisi.',
    hybsgz2: '2. Pengguna dapat mengundang teman, dapat 20USDT modal khusus kontrak untuk setiap undangan berhasil, maksimal 100USDT.',
    hybsgz3: '3. Zona ini hanya untuk pengguna terverifikasi BiKing.',
    hybsgz4: '4. Peringkat berdasarkan total profitabilitas pengguna selama kompetisi.',
    jcfp: 'Alokasi Hadiah:',
    jcfp1: 'Total hadiah: 2.000.000USDT + 30 merchandise',
    fpgz: 'Aturan Alokasi:',
    fpgzs: '(Saat distribusi, modal khusus kontrak dan uang tunai dialokasikan dengan rasio 9:1)',
    fpgz1: 'Peringkat 1: 800.000USDT + 5 merchandise',
    fpgz2: 'Peringkat 2: 500.000USDT + 5 merchandise',
    fpgz3: 'Peringkat 3: 200.000USD + 3 merchandise',
    fpgz4: 'Peringkat 4-20: Berbagi 500.000USDT + 17 merchandise',
    hjyq: 'Syarat Menang',
    hjyq1: '1. Profit kompetisi kontrak = Nilai akhir akun (termasuk unrealized P&L) - Nilai awal akun (termasuk unrealized P&L) - Modal hadiah kontrak.',
    hjyq2: '2. Jika profit sama, pemenang ditentukan oleh volume trading yang lebih tinggi.',
    hjyq3: '3. Profit akun pemenang harus > 0.',
    // Donasi
    gyc1: 'Hadiah ini hanya untuk pengguna zona kontrak dan spot, pengguna dapat menyelesaikan kompetisi lebih awal dan mendonasikan volume/profitabilitas saat ini ke pool amal.',
    gyc2: 'Sistem akan menyumbang ke pool amal dengan rasio 0.5USDT per poin profit, saldo hadiah akan diumumkan di halaman kompetisi',
    gyc3: 'Contoh: Profitabilitas pengguna A 38%, maka sistem menyumbang 38*0.5=19USDT (hadiah amal adalah modal khusus kontrak) ke pool amal.',
    gyc4: 'Batas kumulatif pool amal: 50.000USDT modal khusus kontrak',
    gyc5: 'Saat mendonasikan volume trading, sistem menyumbang dengan rasio 100USDT volume trading = 0.5USDT dana amal, contoh: Volume trading pengguna B 1000USDT, sumbangan ke pool amal 0.5USDT*10=5USDT (hadiah amal adalah modal khusus kontrak)',
    gyc7: 'Yang Perlu Diketahui: Setiap pengguna hanya dapat berdonasi sekali, setelah berdonasi, dianggap mengundurkan diri dari peringkat, hadiah, dan partisipasi kompetisi trading BiKing (pengguna zona kontrak tidak bisa ikut kompetisi spot setelah donasi).',
    gyc8: 'Setelah kompetisi, pool amal akan mengadakan undian 3 putaran, setiap putaran 10 orang berbagi hadiah, rasio alokasi: 40%, 30%, 30%.',
    gyc9: 'Waktu undian: Diundi acak dalam 7 hari kerja setelah kompetisi. Hubungi staf resmi untuk detail.',
    xhjybs: 'Kompetisi Trading Spot',
    xhjybsgzsm: 'Penjelasan Aturan Kompetisi Trading Spot',
    xhjydsphb: 'Papan Peringkat Kompetisi Spot',
    grbmcg: 'Pendaftaran individu berhasil!',
    // Aturan kompetisi spot
    xhgz1: '1. Kompetisi spot mencakup semua pasangan trading spot platform',
    xhgz2: '2. Saldo akun spot pengguna harus > 50USDT',
    xhgz3: '3. Peringkat akhir berdasarkan total volume trading spot pengguna',
    jjfp: 'Alokasi Hadiah',
    zjc: 'Total hadiah: 1.000.000USDT + 20 merchandise',
    xhdym: 'Peringkat 1: 400.000USDT + 10 merchandise',
    xhdem: 'Peringkat 2: 200.000USDT + 5 merchandise',
    xhdsm: 'Peringkat 3: 100.000USDT + 5 merchandise',
    xhdsm1: 'Peringkat 4-20: Berbagi 300.000USDT',
    mypdnpm: 'Papan Peringkat Internal Tim Simulasi',
    yqjl1: 'Hadiah Undangan',
    wdjye: 'Volume Trading Saya:',
    wdzsyl: 'Total Profitabilitas Saya:',
    grzjyl: 'Total Volume Trading Individu Simulasi:',
    grzsyl: 'Total Profitabilitas Individu Simulasi:',
    sqzjye: 'Total Volume Trading Zona Simulasi:',
    zjye: 'Total Volume Trading Zona:',
    bsyqrs: 'Jumlah Undangan Kompetisi:',
    ren: 'orang',
    hdmnj: 'Dapat Modal Simulasi:',
    hdzj: 'Dapat Modal Hadiah:',
    hyjyxq: 'Detail Kompetisi Kontrak',
    xhjyxq: 'Detail Kompetisi Spot',
    hy: 'Kontrak',
    xh: 'Spot',
    jlsm: 'Penjelasan Hadiah:',
    jlsm1: '1. Pengguna (setelah verifikasi) dapat membuat tim kapan saja selama kompetisi, tim kontrak membutuhkan ≥ 5 orang; ≤200 orang; tim bubar otomatis jika kurang dari 5 orang dalam 24 jam.',
    jlsm2: '2. Setiap orang hanya bisa gabung satu tim, tidak bisa ganda, dan tidak bisa keluar tim',
    tdjye: 'Volume Trading Tim:',
    wdjs: 'Peran Saya:',
    dz: 'Kapten',
    dy: 'Anggota',
    tdzyll: 'Total Profitabilitas Tim:',
    wdzyll: 'Total Profitabilitas Saya:',
    tdyjhdjl: 'Perkiraan Hadiah Tim:',
    tdjs1: 'Deskripsi Tim',
    grxq: 'Detail Individu',
    tdxq: 'Detail Tim',
    tdjylpm: 'Peringkat Volume Trading Tim:',
    tdzsyl: 'Total Profitabilitas Tim',
    tdnphb: 'Papan Peringkat Internal Tim',
    tcsybs: 'Tips: Donasi berarti keluar dari semua kompetisi',
    zwcjhybs: 'Belum ikut kompetisi kontrak simulasi',
    zwsj: 'Tidak ada data',
    tdmcbzq: 'Format nama tim tidak benar',
    tdjjbzq: 'Format deskripsi tim tidak benar',
    hdjxz_contract: 'Kompetisi kontrak perpetual sedang berlangsung, ikut kompetisi bagi 2.000.000U hadiah dan menangkan merchandise BiKing',
    hdjxz_spot: 'Kompetisi spot sedang berlangsung, ikut kompetisi bagi 1.000.000U hadiah dan menangkan merchandise BiKing',
    hdjs: 'Tunggu kompetisi berikutnya',
}


// WEBPACK FOOTER //
// ./src/i18n/lang/contest/ba.js